<ng-container *ngIf="{
    row: columnData | async,
    adata: additionData | async
  } as $">

  <button pButton pRipple type="button" icon="fa fa-angle-down" [label]="'common.BUTTONS.BTN_ACTIONS' | translate" iconPos="right"
    class="text-sm text-600 p-button-outlined p-button-secondary border-400 p-2"
    *ngIf="$.row.Type && $.row.Type === 'appointment'" 
    (click)="appointmentAction.toggle($event)" 
    [disabled]="$.row.Status.toLowerCase() === 'attended' || $.row.Status.toLowerCase() === 'completed' 
    || $.row.Status.toLowerCase() === 'cancelled' || $.row.Status.toLowerCase() === 'noshow' ">
  </button>

  <button pButton pRipple type="button" icon="fa fa-angle-down" [label]="'common.BUTTONS.BTN_ACTIONS' | translate" iconPos="right"
    *ngIf="$.row.Type && $.row.Type === 'class'" class="text-sm text-600 p-button-outlined p-button-secondary border-400 p-2"
    (click)="classAction.toggle($event)" [disabled]="$.row.BookingStatus.toLowerCase() === 'cancelled'">
  </button>

  <p-popover #appointmentAction styleClass="overflow-hidden text-sm w-8rem -ml-5">
    <ng-template #content>
      <ul class="list-none -m-4 px-0 py-2 text-xs text-600">
        <li
          *ngIf=" $.adata.includes('reschedule') && $.row.Status.toLowerCase() !== 'attended'"
          (click)=" executeAction('reschedule',$.row,action)"
          class="cursor-pointer hover:surface-300 py-2 px-3 flex align-items-center">
          <i class=" fa fa-envelope font-light text-500 mr-2"></i> {{'CLIENT_BOOKING.ACTIONS.RESCHEDULE' | translate }}
        </li>

        <li *ngIf=" $.adata.includes('cancel')  && $.row.Status.toLowerCase() !== 'cancelled'"
          (click)="executeAction('cancel',$.row,action)"
          class="cursor-pointer hover:surface-300 py-2 px-3 flex align-items-center">
          <i class="fa fa-times-circle text-500 mr-2"></i> {{'CLIENT_BOOKING.ACTIONS.CANCEL' | translate }}
        </li>

        <li
          *ngIf=" $.adata.includes('attended') && $.row.Status.toLowerCase() !== 'attended'"
          (click)=" executeAction('attended',$.row,action)"
          class="cursor-pointer hover:surface-300 py-2 px-3 flex align-items-center">
          <i class="fa fa-check-circle text-500 mr-2"></i>
          {{'CLIENT_BOOKING.ACTIONS.ATTENDED' | translate }}
        </li>
      </ul>
    </ng-template>
  </p-popover>

  <p-popover #classAction styleClass="overflow-hidden text-sm w-8rem -ml-5">
    <ng-template #content>
      <ul class="list-none -m-4 px-0 py-2 text-xs text-600">
        <li
          *ngIf="$.adata.includes('compsession') && ($.row.BookingStatus.toLowerCase() === 'completed' || $.row.BookingStatus.toLowerCase() === 'attended' || $.row.BookingStatus.toLowerCase() === 'noshow')"
          (click)=" executeAction('compsession',$.row,action) "
          class="cursor-pointer hover:surface-300 py-2 px-3 flex align-items-center">
          <i class="fa fa-calendar-times text-500 mr-2"></i> {{ 'CLIENT_BOOKING.ACTIONS.COMPSESSION' | translate }}
        </li>

        <li *ngIf="$.adata.includes('remove') && $.row.BookingStatus.toLowerCase() !== 'completed'"
          (click)="executeAction('remove',$.row,action) "
          class="cursor-pointer hover:surface-300 py-2 px-3 flex align-items-center">
          <i class="fa fa-minus-circle text-500 mr-2"></i>
          {{ 'CLIENT_BOOKING.ACTIONS.REMOVE' | translate }}
        </li>

        <li *ngIf=" $.adata.includes('checkin') && $.row.BookingStatus.toLowerCase() === 'booked'"
          (click)=" executeAction('checkin',$.row,action)"
          class="cursor-pointer hover:surface-300 py-2 px-3 flex align-items-center">
          <i class="fa fa-sign-in text-500 mr-2"></i> {{'CLIENT_BOOKING.ACTIONS.CHECKIN' | translate }}
        </li>

        <li *ngIf=" $.adata.includes('noshow') && ($.row.BookingStatus.toLowerCase() !== 'completed' || $.row.BookingStatus.toLowerCase() !== 'attended')" (click)=" executeAction('noshow',$.row,action)"
          class="cursor-pointer hover:surface-300 py-2 px-3 flex align-items-center">
         <i class="fa fa-ban text-500 mr-2"></i> {{'CLIENT_BOOKING.ACTIONS.NOSHOW' | translate }}
        </li>
        
      </ul>
    </ng-template>
  </p-popover>
</ng-container>
